window.g_replayAction = [];
window.g_currentScene = {};

export class ReplayAction {
    static buildAction(subActionType, offsetTime, detail) {
        var obj = JSON.parse(detail);
        return {
            actionType: subActionType,
            offsetTime: offsetTime,
            detail: obj
        };
    }

    static getReplayActionType(type) {
        switch (type) {
            case "ASRandJudge_":
                return "ASRAndJudgeReplayAction_";
            case "CircleGameInteraction_":
                return "CircleReplayAction_";
            case "MutiMatchGameInteraction_":
                return "MatchReplayAction_";
            case "FlipFlopGameInteraction_":
                return "PurbleReplayAction_";
            case "FacsimileGameInteraction_":
                return "LetterReplayAction_";
            case "AudioMutiMatchGameInteraction_":
                return "AudioMutiMatchReplayAction_";
            case "ChooseWrongWordsInteraction_":
                return "ChooseWrongWordsReplayAction_";
            case "ChooseRightWordsInteraction_":
                return "ChooseRightWordsReplayAction_";
            case "MutiMatchGameWithDoneInteraction_":
                return "MatchWithDoneReplayAction_";
        }
    }

    static buildTimeline(key) {
        var rootAction = {
            actionsID: "0",
            actions: []
        };
        var nodes = [rootAction];
        var links = [];
        for (var i = 0; i < window.g_replayAction[key].length; i++) {
            var node = {};
            node.actionsID = (i + 1).toString();
            node.actions = [];
            node.actions.push(window.g_replayAction[key][i]);
            nodes.push(node);

            var source = 0;
            var target = node.actionsID;
            var delay = parseInt(
                window.g_replayAction[key][i].offsetTime * 1000,
                10
            );
            var link = {
                source: source,
                target: target,
                delay: delay
            };
            links.push(link);
        }
        return {
            nodes: nodes,
            links: links
        };
    }

    static buildReplayAction(key, type) {
        try {
            var oldAction = {};
            var path = "window.g_currentScene" + key;
            eval("oldAction=" + path);
            oldAction.actionType = this.getReplayActionType(type);
            oldAction.detail.timeline = this.buildTimeline(key);
        } catch (error) { }
    }

    static setScene(scene) {
        var _scene = JSON.parse(scene);
        window.g_currentScene = _scene;
    }

    static cleanScene() {
        window.g_currentScene = {};
    }

    static getScene() {
        return JSON.stringify(window.g_currentScene);
    }

    // static begin() {
    //     _actionsMap = new Object()
    // }

    static add(key, subActionType, offsetTime, detail) {
        var subAction = this.buildAction(
            subActionType,
            offsetTime / 1000,
            detail
        );
        if (window.g_replayAction[key] == null) {
            window.g_replayAction[key] = [];
        }
        window.g_replayAction[key].push(subAction);
    }

    static commit(key, type) {
        this.buildReplayAction(key, type);
        window.g_replayAction = [];
    }

    // begin()

    // add(".timeline.nodes[3].actions[0].detail.timeline.nodes[1].actions[0]", "gg", 100, "{}")
    // add(".timeline.nodes[3].actions[0].detail.timeline.nodes[1].actions[0]", "dd", 200, "{}")
    // add(".timeline.nodes[3].actions[0].detail.timeline.nodes[1].actions[0]", "ww", 300, "{}")

    // commit(".timeline.nodes[3].actions[0].detail.timeline.nodes[1].actions[0]", "asr")
    // console.log("%j", g_currentScene)
}



// WEBPACK FOOTER //
// ./src/components/on/ReplayActionBuilder.js